export const GUIDE_PAGE_LABEL = "GUIDE_PAGE_LABEL";
export const GUIDE_PAGE_LABEL_SUCCESS = "GUIDE_PAGE_LABEL_SUCCESS";
export const GUIDE_PAGE_LABEL_FAIL = "GUIDE_PAGE_LABEL_FAIL";
